import { minWidthTablet, minWidthDesktop } from '@funnels/constants';
import { BreakpointNumber, BreakpointSpacing } from '@funnels/types';

///////////////////////////////////////////////////////////////////
// These are separate functions so that the return type is clear //
///////////////////////////////////////////////////////////////////

export function getActiveBreakpointNumber(breakpointValues: BreakpointNumber) {
  const width = window.innerWidth;

  if (width < minWidthTablet()) {
    return breakpointValues.xs;
  } else if (width < minWidthDesktop()) {
    return breakpointValues.lg;
  }

  return breakpointValues.xl;
}

export function getActiveBreakpointSpacing(breakpointValues: BreakpointSpacing) {
  const width = window.innerWidth;

  if (width < minWidthTablet()) {
    return breakpointValues.xs;
  } else if (width < minWidthDesktop()) {
    return breakpointValues.lg;
  }

  return breakpointValues.xl;
}
